<script>
import cartHelper from '@/modules/mixins/cartHelper'

export default {
    name: 'CartPaymentDetails',
    mixins: [cartHelper],
}
</script>

<template lang="pug">
.cart-payment-details(v-if="hasContent" :class="{'bg-white px-5 py-4 border-top border-bottom text-73': smDevice}")
    .payment-line(v-if="minimumOrder > subTotal && subTotal > 0 && isCheckout")
        span.font-weight-lg-medium.font-size-sm.font-size-lg-base.text-danger {{$t('cart.minimum_order').capitalize()}}
            |  {{ minimumOrder | toCurrency(currency.locale, currency.currency_code) }}
    .payment-line(v-if="subTotal")
        span.font-weight-lg-medium.font-size-sm.font-size-lg-base {{$t('order.subtotal')}}
        span.font-weight-lg-medium.font-size-sm.font-size-lg-base  {{ subTotal | toCurrency(currency.locale, currency.currency_code) }}
        .d-flex.align-items-center.w-100.font-size-sm.text-73.line-1(v-if="restaurantDiscount")
            icon.text-primary.mr-2(icon="tag" size="sm")
            | {{ $t('order.discount', {price: $options.filters.toCurrency(restaurantDiscount, currency.locale, currency.currency_code)}) }}
    .payment-line(v-if="deliveryPrice >= 0 && !wrongAddress")
        span.font-weight-lg-medium.font-size-sm.font-size-lg-base {{$t('order.delivery_fee')}}
        span.font-weight-lg-medium.font-size-sm.font-size-lg-base(:class="{'text-primary': deliveryPriceHighlight}")
            s.text-73.mr-3(v-if="deliveryPriceHighlight") {{ originalDeliveryPrice | toCurrency(currency.locale, currency.currency_code) }}
            template(v-if="deliveryPrice === 0") {{ $t('order.free') }}
            template(v-else) {{ deliveryPrice | toCurrency(currency.locale, currency.currency_code) }}
    .payment-line(v-if="promotionUserDiscount > 0")
        span.font-weight-lg-medium.font-size-sm.font-size-lg-base {{$t('order.promotion_discount')}}
        span.font-weight-lg-medium.font-size-sm.font-size-lg-base.text-primary -{{ promotionUserDiscount | toCurrency(currency.locale, currency.currency_code) }}
    .payment-line(v-if="promotionCompanyDiscount > 0")
        span.font-weight-lg-medium.font-size-sm.font-size-lg-base {{$t('order.promotion_discount')}}
        span.font-weight-lg-medium.font-size-sm.font-size-lg-base.text-primary -{{ promotionCompanyDiscount | toCurrency(currency.locale, currency.currency_code) }}
    .payment-line(v-if="couponItemDiscount > 0")
        span.font-weight-lg-medium.font-size-sm.font-size-lg-base {{$t('order.coupon_discount')}}
        span.font-weight-lg-medium.font-size-sm.font-size-lg-base.text-primary -{{ couponItemDiscount | toCurrency(currency.locale, currency.currency_code) }}
    .payment-line(v-if="referralDiscount > 0")
        span.font-weight-lg-medium.font-size-sm.font-size-lg-base {{$t('order.referral_discount')}}
        span.font-weight-lg-medium.font-size-sm.font-size-lg-base.text-primary -{{ referralDiscount | toCurrency(currency.locale, currency.currency_code) }}
    .payment-line(v-if="paidByCompany > 0 && allowance")
        span.font-weight-lg-medium.font-size-sm.font-size-lg-base.max-w-70 {{ allowance.name }}
        span.font-weight-lg-medium.font-size-sm.font-size-lg-base.text-primary -{{ paidByCompany | toCurrency(currency.locale, currency.currency_code) }}
    .payment-line(v-if="companyServiceFee > 0")
        span.font-weight-lg-medium.font-size-sm.font-size-lg-base {{$t('order.company_service_fee')}}
        span.font-weight-lg-medium.font-size-sm.font-size-lg-base {{ companyServiceFee | toCurrency(currency.locale, currency.currency_code) }}
    template(v-if="hasContent && lgDevice")
        hr.card-separator
        .payment-line
            span.font-weight-semibold {{$t('order.total_paid')}}
            span.font-weight-semibold {{ paidByUser | toCurrency(currency.locale, currency.currency_code) }}
</template>
